import SelectableCard from '@/components/SelectableCard/SelectableCard';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './EcommOptionsList.styles';

interface SelectableCardItem {
  id: string;
  label: string;
}

interface SelectableCardListProps {
  label: string;
  heading?: string;
  name: string;
  items: SelectableCardItem[] | undefined;
  selectedId: string;
  onSelect: (id: string) => void;
  onHover?: (id: string, isEntering: boolean) => void;
  showRadio?: boolean;
  optionsContainerClassName?: string;
  cardContentClassName?: string;
  className?: string;
  increaseCardPadding?: boolean;
  'data-testid'?: string;
}

const EcommOptionsList: React.FC<SelectableCardListProps> = ({
  label,
  heading,
  name,
  items,
  selectedId,
  onSelect,
  onHover,
  showRadio,
  cardContentClassName,
  optionsContainerClassName,
  className,
  increaseCardPadding = false,
  'data-testid': dataTestId,
}) => {
  const { classes, cx } = useStyles();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });

  return (
    <div
      role='radiogroup'
      aria-label={label}
      data-testid={dataTestId}
      className={className}
    >
      {heading && <h4 className={globalClasses.h4}>{heading}</h4>}
      <div className={cx(classes.optionsContainer, optionsContainerClassName)}>
        {items?.map(({ id, label }) => (
          <SelectableCard
            key={id}
            name={name}
            value={id}
            isSelected={selectedId === id}
            onSelect={() => onSelect(id)}
            onHover={onHover}
            ariaLabel={label}
            showRadio={showRadio}
            increasePadding={increaseCardPadding}
          >
            <div className={cardContentClassName}>{label}</div>
          </SelectableCard>
        ))}
      </div>
    </div>
  );
};

export default EcommOptionsList;
